module.exports = __webpack_public_path__ + "static/media/urban-farming-tablet.78766c18.jpg";